// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amp-layout__wrapper .footer__terms{margin:0;padding-top:10px;border-top:1px solid #fff}", ""]);
// Exports
module.exports = exports;
